// Generated by ReScript, PLEASE EDIT WITH CARE

import * as I18n from "../../primitives/I18n.res.js";
import * as Badge from "../../resources/feedback-indicators/Badge.res.js";
import * as React from "react";
import * as JsxRuntime from "react/jsx-runtime";
import * as CanarySummaryAmounts from "../../resources/data-visualizations/CanarySummaryAmounts.res.js";

function formatCurrency(value) {
  return I18n.currencyFormat(undefined, "EUR", 2, 2, value);
}

function formatPercentage(value) {
  let rate = value / 100;
  return I18n.percentFormat(undefined, undefined, 1, rate);
}

function SaleCartSummaryAmounts(props) {
  let taxesIncluded = props.taxesIncluded;
  let totalAmountExcludingTaxes = props.totalAmountExcludingTaxes;
  let discounts = props.discounts;
  let hasDiscounts = discounts.length !== 0;
  let subtotalLabel = taxesIncluded ? I18n.t("Subtotal incl. VAT") : I18n.t("Subtotal excl. VAT");
  return JsxRuntime.jsxs(CanarySummaryAmounts.make, {
    children: [
      hasDiscounts ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(CanarySummaryAmounts.Line.make, {
              label: subtotalLabel,
              value: props.totalAmountBeforeDiscounts
            }),
            discounts.map(discount => {
              let formattedValue = discount.isPercentage ? "-" + formatPercentage(discount.value) : "-" + formatCurrency(discount.value);
              return JsxRuntime.jsx(CanarySummaryAmounts.Line.make, {
                variant: "info",
                label: discount.name,
                valueElement: JsxRuntime.jsx(Badge.make, {
                  children: formattedValue,
                  size: "normal",
                  variation: "information"
                })
              }, discount.name);
            }),
            JsxRuntime.jsx(CanarySummaryAmounts.Gap.make, {})
          ]
        }) : null,
      props.taxesExempted ? JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            hasDiscounts ? null : JsxRuntime.jsx(CanarySummaryAmounts.Gap.make, {}),
            JsxRuntime.jsx(CanarySummaryAmounts.Line.make, {
              variant: "strong",
              label: I18n.t("Total amount"),
              value: totalAmountExcludingTaxes
            }),
            JsxRuntime.jsx(CanarySummaryAmounts.Caption.make, {
              children: I18n.template(I18n.t("{{amount}} of deductible VAT ({{percent}})"), {
                amount: formatCurrency(0.00),
                percent: formatPercentage(0.00)
              }, undefined)
            })
          ]
        }) : JsxRuntime.jsxs(JsxRuntime.Fragment, {
          children: [
            JsxRuntime.jsx(CanarySummaryAmounts.Line.make, {
              variant: taxesIncluded ? "default" : "strong",
              label: I18n.t("Total amount excl. VAT"),
              value: totalAmountExcludingTaxes
            }),
            props.taxes.map(tax => JsxRuntime.jsxs(React.Fragment, {
              children: [
                JsxRuntime.jsx(CanarySummaryAmounts.Line.make, {
                  label: I18n.t("VAT") + " " + formatPercentage(tax.rate),
                  value: tax.taxAmount
                }, tax.rate.toString()),
                JsxRuntime.jsx(CanarySummaryAmounts.Line.make, {
                  variant: "subtle",
                  label: I18n.t("VAT excl. base") + " " + formatPercentage(tax.rate),
                  value: tax.baseAmount
                }, tax.rate.toString() + "_base")
              ]
            }, tax.rate.toString())),
            JsxRuntime.jsxs(JsxRuntime.Fragment, {
              children: [
                hasDiscounts ? null : JsxRuntime.jsx(CanarySummaryAmounts.Gap.make, {}),
                JsxRuntime.jsx(CanarySummaryAmounts.Line.make, {
                  variant: taxesIncluded ? "strong" : "default",
                  label: I18n.t("Total amount incl. VAT"),
                  value: props.totalAmountIncludingTaxes
                })
              ]
            })
          ]
        })
    ],
    fractionDigits: 2
  });
}

let make = React.memo(SaleCartSummaryAmounts);

export {
  formatCurrency,
  formatPercentage,
  make,
}
/* make Not a pure module */
